(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

window.chosenBrowserIsSupported = function () {
  if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
    return false
  }
  if (/Android/i.test(window.navigator.userAgent)) {
    if (/Mobile/i.test(window.navigator.userAgent)) {
      return false
    }
  }
  if (/IEMobile/i.test(window.navigator.userAgent)) {
    return false
  }
  if (/Windows Phone/i.test(window.navigator.userAgent)) {
    return false
  }
  if (/BlackBerry/i.test(window.navigator.userAgent)) {
    return false
  }
  if (/BB10/i.test(window.navigator.userAgent)) {
    return false
  }
  if (window.navigator.appName === 'Microsoft Internet Explorer') {
    return document.documentMode >= 8
  }

  return true
}

window.initializeChosen = function () {
  $('select').chosen({
    disable_search: true,
    inherit_select_classes: true
  })

  if (!window.chosenBrowserIsSupported()) {
    $('select').each(function () {
      let placeholder = $(this).data('placeholder')

      let option = $(this).find('option').first()
      option.val(0)
      option.text(placeholder)
      option.attr('disabled', true)
      option.attr('selected', 'selected')
    })
  }
}

$(() => {
  window.initializeChosen()
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_chosen.js","/")